module.exports = __webpack_public_path__ + "img/logoFull.f29c52db.png";